import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const bvSectionSx:SxProps = {
    px:globalBreak({mobile:2, desktop:4}),
    '& *':{
        bgcolor:'#fff !important'
    }
}